var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgPublishIconDefault = function SvgPublishIconDefault(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0481A0",
    fillRule: "evenodd",
    d: "M22.562 10.746 16 3.08l-6.563 7.666a.515.515 0 0 0 .407.831h2.002v3.585a.46.46 0 0 0 .462.461h7.384a.461.461 0 0 0 .462-.461v-3.585h2.002c.428 0 .67-.493.406-.83zm1.858-.281c.08.302.11.612.066.923h.745v12H6.77v-12h.744a2.32 2.32 0 0 1 .066-.923H5.846v13.847h20.308V10.465H24.42zm5.427-3.693v18.463c0 1.53-1.24 2.769-2.77 2.769H4.923a2.77 2.77 0 0 1-2.77-2.77V6.773c0-1.53 1.24-2.769 2.77-2.769h7.856L8.827 8.62H4v16.616c0 .51.413.923.923.923h22.154a.924.924 0 0 0 .923-.923V8.619h-4.828L19.22 4.003h7.857a2.77 2.77 0 0 1 2.77 2.77z"
  })));
};

export default SvgPublishIconDefault;